const resourceStatuses = {
  getResourceStatusName(resource) {
    if (resource.scheduledCount > 0) {
      return "Scheduled";
    } else if (resource.sentCount > 0) {
      return "Sent";
    }
    return "Ready";
  },
  getResourceStatusColor(resource) {
    if (resource.scheduledCount > 0) {
      return "primary";
    } else if (resource.sentCount > 0) {
      return "success";
    }
    return "info";
  }
};

export default { methods: resourceStatuses };
